<template>
  <section class="cuadro-ingreso">
    <form class="cuadro-ingreso__body sombra" novalidate @submit.stop.prevent="login()">
      <div class="text--center">
        <img src="/logo.png" class="logo-login img--center" alt="Logo Panthera" width="50%">
      </div>
      <h1 class="h4 text--blanco text--center text--bold">Inspecciones de Ataques - PWA</h1>
      <h2 class="h5 text text--blanco text--center">Por favor ingrese sus credenciales</h2>
      <form-group :error="errors.has(ids.correo) && submitted">
        <input type="text"
               autofocus
               :id="ids.correo"
               :name="ids.correo"
               class="form__input form__input--blanco"
               v-model="usuario"
               required
               v-validate="'required|email'"
               @input="usuario = usuario.toLowerCase().trim()">
        <label :for="ids.correo" class="form__label form__input--blanco">Correo</label>
      </form-group>
      <form-group :error="errors.has(ids.password) && submitted">
        <input type="password"
               :id="ids.password"
               :name="ids.password"
               class="form__input form__input--blanco"
               v-model="password"
               required
               v-validate="'required'">
        <label :for="ids.password" class="form__label form__input--blanco">Contraseña</label>
      </form-group>
      <div class="switch switch--ambar">
        <input type="checkbox" id="recordar" v-model="recordar">
        <label class="form__label text--blanco" for="recordar">Mantener sesión iniciada</label>
      </div>
      <br>
      <div class="text--center">
        <button class="boton boton--tema boton--l" type="submit">
          <i class="fa fa-fw fa-sign-in"/>
          Iniciar sesión
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import D from "debug";
import noop from "lodash/noop";
import id from "../ids.js";

const debug = D("ciris:Login.vue");

export default {
  name: "Login",
  data,
  created,
  methods: {
    login,
  },
};

function data() {
  return {
    ids: {},
    usuario: "",
    password: "",
    recordar: true,
    submitted: false,
  };
}

function created() {
  this.ids = {
    correo: `correo-${id()}`,
    password: `password-${id()}`,
  };
}

function login() {
  const comp = this;
  this.submitted = true;
  return this.$validator.validateAll().then((valido) => {
    if (valido) {
      return this.$auth.login(this.usuario, this.password, this.recordar)
        .then((resp) => {
          debug(resp);
          comp.$router.push({ name: "formularios" });
          comp.$toastr("success", "Bienvenido", `${resp.usuario.nombre}`);
          return resp;
        })
        .catch((err) => {
          debug(err);
          if (err.response.status < 500) {
            comp.$toastr("info", "Parece que la información ingresada está incorrecta", "Credenciales invalidos");
          } else {
            comp.$toastr("error", "Sucedió un error logueandose, intente nuevamente", "Error");
          }
        });
    }
    return noop;
  });
}
</script>

<style src="./login.scss" lang="scss"/>
